import { createAction, props } from '@ngrx/store';
import { DailyLead, DailyLeadRun, IcpAdjustmentNotification, PaginationMeta } from '../../pages/leads-legacy/lead.model';

export const loadDailyLeads = createAction(
  '[DailyLead] Load Daily Leads',
  props<{ params?: { filter?: { status?: string; icp_id?: number }; sort?: string; per_page?: number; page?: number } }>()
);

export const loadDailyLeadsSuccess = createAction(
  '[DailyLead] Load Daily Leads Success',
  props<{ leads: DailyLead[]; meta: PaginationMeta }>()
);

export const loadDailyLeadsFailure = createAction(
  '[DailyLead] Load Daily Leads Failure',
  props<{ error: any }>()
);

export const loadDailyLeadDetail = createAction(
  '[DailyLead] Load Daily Lead Detail',
  props<{ id: string }>()
);

export const loadDailyLeadDetailSuccess = createAction(
  '[DailyLead] Load Daily Lead Detail Success',
  props<{ lead: DailyLead }>()
);

export const loadDailyLeadDetailFailure = createAction(
  '[DailyLead] Load Daily Lead Detail Failure',
  props<{ error: any }>()
);

export const clearDailyLeadDetail = createAction(
  '[DailyLead] Clear Daily Lead Detail'
);

export const generateDailyLeads = createAction(
  '[DailyLead] Generate Daily Leads',
  props<{ count: number; icp_id: number }>()
);

export const generateDailyLeadsSuccess = createAction(
  '[DailyLead] Generate Daily Leads Success',
  props<{ message: string; creditsDeducted: number; estimatedLeads: number }>()
);

export const generateDailyLeadsFailure = createAction(
  '[DailyLead] Generate Daily Leads Failure',
  props<{ error: any }>()
);

export const loadDailyLeadRuns = createAction(
  '[DailyLead] Load Daily Lead Runs',
  props<{ params?: { filter?: { icp_id?: number; status?: string; run_type?: string; run_date?: string }; sort?: string; per_page?: number; page?: number } }>()
);

export const loadDailyLeadRunsSuccess = createAction(
  '[DailyLead] Load Daily Lead Runs Success',
  props<{ runs: DailyLeadRun[]; meta: PaginationMeta }>()
);

export const loadDailyLeadRunsFailure = createAction(
  '[DailyLead] Load Daily Lead Runs Failure',
  props<{ error: any }>()
);

export const loadNotifications = createAction(
  '[DailyLead] Load Notifications',
  props<{ params?: { page?: number; per_page?: number } }>()
);

export const loadNotificationsSuccess = createAction(
  '[DailyLead] Load Notifications Success',
  props<{ notifications: IcpAdjustmentNotification[]; meta: PaginationMeta; unreadCount: number }>()
);

export const loadNotificationsFailure = createAction(
  '[DailyLead] Load Notifications Failure',
  props<{ error: any }>()
);

export const markAllNotificationsRead = createAction(
  '[DailyLead] Mark All Notifications Read'
);

export const markAllNotificationsReadSuccess = createAction(
  '[DailyLead] Mark All Notifications Read Success'
);

export const markAllNotificationsReadFailure = createAction(
  '[DailyLead] Mark All Notifications Read Failure',
  props<{ error: any }>()
);
